var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "limits-manager" },
    [
      _c("h2", { staticClass: "limits-manager__title text_large" }, [
        _vm._v(
          _vm._s(
            _vm.i18n.lim_change_limits_title({
              assetName: _vm.assetName,
              asset: _vm.asset
            })
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "limits-manager__select" },
        [
          _c("select-field", {
            staticClass: "limits-manager__select-field",
            attrs: {
              values: Object.values(_vm.LIMIT_OPS_STR),
              label: _vm.i18n.lim_operation_type_limit_label()
            },
            model: {
              value: _vm.form.operationType,
              callback: function($$v) {
                _vm.$set(_vm.form, "operationType", $$v)
              },
              expression: "form.operationType"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-table",
        { staticClass: "limits-manager__table" },
        [
          _c(
            "md-table-row",
            { staticClass: "limits-manager__table-row" },
            [
              _c(
                "md-table-head",
                { staticClass: "limits-manager__table-head" },
                [_vm._v(_vm._s(_vm.i18n.lbl_to()))]
              ),
              _vm._v(" "),
              _c(
                "md-table-head",
                {
                  staticClass:
                    "limits-manager__table-head limits-manager__table-head--right"
                },
                [_vm._v(_vm._s(_vm.i18n.lim_limits()))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-table-row",
            { staticClass: "limits-manager__table-row" },
            [
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c(
                    "span",
                    { staticClass: "limits-manager__limit-type text_medium" },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.i18n.lim_daily()) + "\n      "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c("editable-input-field", {
                    staticClass: "field__number",
                    attrs: {
                      value: _vm.form.limits.dailyOut,
                      step: _vm.DEFAULT_INPUT_STEP,
                      fieldId: "1",
                      type: "number",
                      name: "daily limit amount",
                      nowrap: true,
                      iconSize: "18",
                      align: "right",
                      min: "0",
                      errorMessage: _vm.errorMessage("daily limit amount")
                    },
                    on: {
                      "changed-value": function($event) {
                        _vm.form.limits.dailyOut = $event.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-table-row",
            { staticClass: "limits-manager__table-row" },
            [
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c(
                    "span",
                    { staticClass: "limits-manager__limit-type text_medium" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.i18n.lim_weekly()) +
                          "\n      "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c("editable-input-field", {
                    staticClass: "field__number",
                    attrs: {
                      value: _vm.form.limits.weeklyOut,
                      step: _vm.DEFAULT_INPUT_STEP,
                      fieldId: "2",
                      type: "number",
                      name: "weekly limit amount",
                      nowrap: true,
                      iconSize: "18",
                      align: "right",
                      errorMessage: _vm.errorMessage("weekly limit amount")
                    },
                    on: {
                      "changed-value": function($event) {
                        _vm.form.limits.weeklyOut = $event.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-table-row",
            { staticClass: "limits-manager__table-row" },
            [
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c(
                    "span",
                    { staticClass: "limits-manager__limit-type text_medium" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.i18n.lim_monthly()) +
                          "\n      "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c("editable-input-field", {
                    staticClass: "field__number",
                    attrs: {
                      value: _vm.form.limits.monthlyOut,
                      step: _vm.DEFAULT_INPUT_STEP,
                      fieldId: "3",
                      type: "number",
                      name: "monthly limit amount",
                      nowrap: true,
                      iconSize: "18",
                      align: "right",
                      errorMessage: _vm.errorMessage("monthly limit amount")
                    },
                    on: {
                      "changed-value": function($event) {
                        _vm.form.limits.monthlyOut = $event.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-table-row",
            { staticClass: "limits-manager__table-row" },
            [
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c(
                    "span",
                    { staticClass: "limits-manager__limit-type text_medium" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.i18n.lim_annual()) +
                          "\n      "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-table-cell",
                { staticClass: "limits-manager__table-cell" },
                [
                  _c("editable-input-field", {
                    staticClass: "field__number",
                    attrs: {
                      value: _vm.form.limits.annualOut,
                      step: _vm.DEFAULT_INPUT_STEP,
                      fieldId: "4",
                      type: "number",
                      name: "annual limit amount",
                      nowrap: true,
                      iconSize: "18",
                      align: "right",
                      errorMessage: _vm.errorMessage("annual limit amount")
                    },
                    on: {
                      "changed-value": function($event) {
                        _vm.form.limits.annualOut = $event.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-table-row",
            { staticClass: "limits-manager__table-row" },
            [
              _c(
                "md-table-cell",
                {
                  staticClass: "limits-manager__table-cell-note",
                  attrs: { colspan: "2" }
                },
                [
                  _c("h3", { staticClass: "limits-manager__note-label" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_note()))
                  ]),
                  _vm._v(" "),
                  _c("textarea-field", {
                    staticClass: "limits-manager__note-field",
                    model: {
                      value: _vm.form.note,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "note", $$v)
                      },
                      expression: "form.note"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap space-between" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { disabled: _vm.isPending },
              on: { click: _vm.closeForm }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { disabled: _vm.isPending },
              on: { click: _vm.submit }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_send_request()))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83ab7524", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83ab7524","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/limits/Limits.Manager.vue
// module id = ZblA
// module chunks = 1